import numeral from "numeral";
import numberToWords from "number-to-words";

const percentage = value => numeral(value).format("0.[00]%");

const separator = value => numeral(value).format("0,0");

const currency = value => numeral(value).format("$0,0.00");

const currencyShort = value => numeral(value).format("$0,0");

const currencyBig = value => numeral(value).format("$0,0.0a");

const two_decimals = value => numeral(value).format("0.00");

const one_decimal = value => numeral(value).format("0.0");

const no_decimal = value => numeral(value).format("0");

const no_decimal_abs = value => numeral(Math.abs(value)).format("0");

const ordinal_words = value => numberToWords.toWordsOrdinal(value);

export default {
  percentage,
  separator,
  currency,
  currencyShort,
  currencyBig,
  two_decimals,
  one_decimal,
  no_decimal,
  no_decimal_abs,
  ordinal_words
};
